import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const loadGAScript = (trackingId) => {
  if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${trackingId}"]`)) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', trackingId);
    };
  }
};

const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN;

    if (trackingId) {
      loadGAScript(trackingId);

      if (window.gtag) {
        window.gtag('config', trackingId, {
          page_path: location.pathname,
        });
      }
    }
  }, [location]);
};

export default usePageViews;
